import React, { useState } from 'react';
import Modal, { useModal } from 'mrf/view/Modal';
import PageTitle from 'mrf/view/Title';
import Flex from 'mrf/layout/Flex';

const Dialog = ({ children, toggle }) => {
    const context = useModal();

    return (
        <Modal toggle={toggle} modal={context.modal}>
            {children}
        </Modal>
    );
};

export const DialogTitle = ({ children }) => <PageTitle>{children}</PageTitle>;

export const DialogContent = ({ children }) => <div className='py-3'>{children}</div>;

export const DialogActions = ({ children }) => <Flex>{children}</Flex>;

export const useDialog = () => {
    const [open, setOpen] = useState(false);

    const toggle = () => setOpen(!open);

    return { toggle };
};

export default Dialog;
